import { z } from "zod";

export enum AdminRoles {
	ADMIN = "admin"
}

export const adminModel = z.object({
	id: z.string(),
	email: z.string(),
	isActive: z.boolean().optional(),
	role: z.enum(["admin"])
});

export type AdminModel = z.infer<typeof adminModel>;

export const adminChartStatsModel = z.object({
	date: z.string(),
	value: z.number()
});

export type AdminChartStatsModel = z.infer<typeof adminChartStatsModel>;

export const adminRevenueStatsModel = z.object({
	totalRevenue: z.number(),
	dailyRevenue: z.number(),
	chart: adminChartStatsModel.array()
});

export type AdminRevenueStatsModel = z.infer<typeof adminRevenueStatsModel>;

export const adminUsersStatsModel = z.object({
	totalUsers: z.number(),
	totalInvestors: z.number(),
	totalIssuers: z.number(),
	newInvestorRegistrations: z.number(),
	newIssuerRegistrations: z.number(),
	chart: adminChartStatsModel.array()
});

export type AdminUsersStatsModel = z.infer<typeof adminUsersStatsModel>;

export const adminIssuancesStatsModel = z.object({
	total: z.number(),
	awaitingApproval: z.number(),
	awaitingDeployment: z.number(),
	chart: adminChartStatsModel.array()
});

export type AdminIssuancesStatsModel = z.infer<typeof adminIssuancesStatsModel>;

export const adminTransactionsStatsModel = z.object({
	totalBuys: z.number(),
	totalSells: z.number(),
	totalOffers: z.number(),
	chart: adminChartStatsModel.array()
});

export type AdminTransactionsStatsModel = z.infer<typeof adminTransactionsStatsModel>;
